import { t } from 'i18next';

import { ErrorResponseErrorItemCodeCoordinateSystem } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeCoordinateSystem, string> => ({
  'coordinate_system:not_found': t('coordinateSystem.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Koordinatsystemet kunde inte hittas.',
  }),
});
